import { render } from "./FeeTable.vue?vue&type=template&id=58def7f9&scoped=true"
import script from "./FeeTable.vue?vue&type=script&lang=js"
export * from "./FeeTable.vue?vue&type=script&lang=js"

import "./FeeTable.vue?vue&type=style&index=0&id=58def7f9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58def7f9"]])

export default __exports__